import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteProvider } from './context/SiteContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Departments from './pages/Departments';
import DepartmentDetail from './pages/DepartmentDetail';
import Services from './pages/Services';
import ServiceDetail from './pages/ServiceDetail';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Notices from './pages/Notices';
import NoticeDetail from './pages/NoticeDetail';
import Tenders from './pages/Tenders';
import TenderDetail from './pages/TenderDetail';
import Downloads from './pages/Downloads';
import Gallery from './pages/Gallery';
import GalleryDetail from './pages/GalleryDetail';
import RTI from './pages/RTI';
import Grievance from './pages/Grievance';
import Contact from './pages/Contact';
import Search from './pages/Search';
import PageView from './pages/PageView';
import './App.css';

function App() {
  return (
    <SiteProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<About />} />
            <Route path="departments" element={<Departments />} />
            <Route path="departments/:slug" element={<DepartmentDetail />} />
            <Route path="services" element={<Services />} />
            <Route path="services/:slug" element={<ServiceDetail />} />
            <Route path="news" element={<News />} />
            <Route path="news/:slug" element={<NewsDetail />} />
            <Route path="notices" element={<Notices />} />
            <Route path="notices/:slug" element={<NoticeDetail />} />
            <Route path="tenders" element={<Tenders />} />
            <Route path="tenders/:slug" element={<TenderDetail />} />
            <Route path="downloads" element={<Downloads />} />
            <Route path="gallery" element={<Gallery />} />
            <Route path="gallery/:slug" element={<GalleryDetail />} />
            <Route path="rti" element={<RTI />} />
            <Route path="grievance" element={<Grievance />} />
            <Route path="contact" element={<Contact />} />
            <Route path="search" element={<Search />} />
            <Route path="page/:slug" element={<PageView />} />
          </Route>
        </Routes>
      </Router>
    </SiteProvider>
  );
}

export default App;
